var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08446 5.11106L0.214455 1.24406C0.146486 1.17641 0.0925509 1.09601 0.055748 1.00745C0.0189451 0.918903 -4.10531e-07 0.823955 -4.14723e-07 0.72806C-4.18915e-07 0.632165 0.0189451 0.537216 0.055748 0.448665C0.0925508 0.360113 0.146486 0.279706 0.214455 0.21206C0.352363 0.0760574 0.538266 -0.000189805 0.731955 -0.000189813C0.925644 -0.000189822 1.11155 0.0760574 1.24946 0.21206L5.63346 4.59306C5.76614 4.72601 5.84239 4.90505 5.8463 5.09284C5.85022 5.28064 5.78149 5.4627 5.65446 5.60106L1.25246 10.0131C1.11452 10.145 0.930447 10.2178 0.739578 10.2158C0.548708 10.2138 0.366184 10.1372 0.231015 10.0025C0.095847 9.86769 0.0187578 9.68539 0.016224 9.49452C0.0136901 9.30366 0.0859126 9.11938 0.217455 8.98106L4.08446 5.11106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDown);
export default __webpack_public_path__ + "static/media/right-arrow-down.b60a08a1ec0f55119cb4ee42f9d04430.svg";
export { ForwardRef as ReactComponent };